import { IPromise, IHttpService, IQService, IWindowService } from "angular";

export const EMAIL_CONFIRMED_SERVICE = "emailConfirmedService";

export class EmailConfirmedService {
    static $inject = ["$http", "$q", "$window", "BoardWebAdminUserManager"];
    constructor(private $http: IHttpService, private $q: IQService, private $window: IWindowService, private userManager: Oidc.UserManager) { }

    confirmEmail(userId: string, confirmationToken: string): IPromise<any> {
        return this.$http.get<string>("api/register/ConfirmEmail", {
            params: {
                confirmationToken: confirmationToken,
                userId: userId
            }
        }).then((response) => {
            return response.data;
        });
    }
}



// WEBPACK FOOTER //
// ./app/email-confirmed/email-confirmed.service.ts